export default "__VITE_ASSET__DkJDJpI6__"